import React from 'react';
import Header from '../Header/Header';
import { SearchModel } from './SearchModel';



const Search = () => {
    const searchModel = SearchModel();
    return (
        <>
            <Header />
            <div className="container mt-5">
                <div className="row mt-5">
                    <div className="col-md-12  mt-5 mb-4">
                        <input type="text" className="form-control" placeholder='Search Ticker' onChange={searchModel.handleChange}/>
                    </div>
                    {
                        searchModel.lstFilterTickers && searchModel.lstFilterTickers.map((d: any, index: number) => (
                            <>
                            <div className="col-md-12 text-light text-start mb-3" key={index} onClick={(e)=>searchModel.viewStockDetails(d)}>
                                <p className='m-0'><strong>{d.symbol}</strong></p>
                                <label htmlFor="">{d.name}</label>
                            </div>
                            <hr />
                            </>
                        ))
                    }
                </div>
            </div>
        </>
    )
}

export default Search;